import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const SelectOptionTop = ({ value, onChange, options, ariaLabel }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setMenuStyle({
      left: 0,
      bottom: "calc(100% + 6px)",
    });
  }, [open]);

  const selected = options.find((o) => o.value === value);

  return (
    <div
      className="select-option"
      ref={ref}
      style={{ position: "relative", display: "inline-block" }}
    >
      <button
        type="button"
        className={`lang-toggle ${open ? "open" : ""}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((s) => !s)}
      >
        <span className="lang-label">{selected ? selected.label : ""}</span>
        <svg
          className="caret-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="#374151"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <ul
          className="lang-menu"
          role="menu"
          aria-label={ariaLabel}
          style={menuStyle}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              role="menuitem"
              className={opt.value === value ? "selected" : ""}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              <span>{opt.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

SelectOptionTop.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  ariaLabel: PropTypes.string,
};

SelectOptionTop.defaultProps = {
  ariaLabel: "select-top",
};

export default SelectOptionTop;
